
import React, { Component } from 'react';
import styles from './index.css';
import Dropdown from '@com-pc/dropdown';
import { hocToolbarItem } from './toolbar-item-hoc';
import GridMenu from './menu/grid-menu';
import FontMenu from './menu/font-menu';
import EffectMenu from './menu/effect-menu';
import OptionMenu from '@src/framework/frame/components/option-menu';
import { ActionType } from '../../../editor/src/js/constants/common-action-type';
import { autorun } from 'mobx';
import { ItemSymbolType, DropdownType } from '../../../editor/src/js/constants/toolbar-data';
import { OfficeNumberType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/character-type';
import classNames from 'classnames';
import { StyleMode } from '../../../editor/src/js/constants/float-toobbar-data';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '../../../../slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import CropPanel from './../../../frame-pc/components/crop-panel/index';
import ChartComponentEditPanel from './../../../frame-pc/components/chart-component-edit-panel/index';
import { shouldShowNewFeatureIntroRedPoint } from '../../../../utils/whats-new';
import Badge from '@tencent/dui/lib/components/Badge';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { IAddonHandler } from '@src/slide/application/service/addon/addon-handler.interface';
import { IElementModelProps } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/element-model-props.interface';
import { IRightSideBarManager } from '@src/slide/application/service/right-side-bar-manager/right-side-bar-manager.interface';
import {
    IndentType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';

const Content = (item) => {
    const renderComponentTemplate = <div onClick={item.onContentClick} style={{ display: 'flex', alignItems: 'center' }}>
        <img className={classNames({
            [styles.icon]: !item.isDoubleMode,
            [styles.doubleIcon]: !!item.isDoubleMode,
            [styles.hover]: item.dropdownHover,
            [styles.selected]: item.iconSelected,
        })}
        src={item.icon} />
        {item.titleContent && <p className={styles.titleContent}>{item.titleContent}</p>}
    </div>;
    const canShowRedPoint = shouldShowNewFeatureIntroRedPoint(item.id);
    return canShowRedPoint ? <Badge dot>{renderComponentTemplate}</Badge> : renderComponentTemplate;
};

const DropContent = (props: any) => {
    switch (props.type) {
        case DropdownType.EFFECT: return <EffectMenu {...props}></EffectMenu>;
        case DropdownType.CROP: return <CropPanel {...props}></CropPanel>;
        case DropdownType.CUSTOM: return <FontMenu {...props}></FontMenu>;
        case DropdownType.ADDON: return <OptionMenu {...props}></OptionMenu>;
        case DropdownType.CHART_COMPONENT: return <ChartComponentEditPanel {...props}/>;
        default: return <GridMenu {...props} ></GridMenu>;
    }
};
interface ToolbarItemImageProps {
    id: string;
    value: string;
    keyIndex: number;
    model: string;
    disabled: boolean;
    autoClosDropDown: boolean;
    noShadow: boolean;
    isChart: boolean;
    showSelectedValue: boolean;
    icon: string;
    dropdown: {
        checkSelectedValue: boolean;
        data: any[];
        type: string;
        itemWidth: number;
        itemHeight: number;
        itemPadding: number | string;
        showBorder: boolean;
    };
    rightSideBarManager: IRightSideBarManager;
    handleClick: (id: string, value?: any, options?: any) => void;
}
interface ToolbarItemImageState {
    selected: boolean;
    selectedIndex: number;
}

const ItemComponent = hocToolbarItem(Content);
export default class ToolbarItemImage extends Component<ToolbarItemImageProps, ToolbarItemImageState> {
    private autorun: any;
    private num: number;
    private dropDom: Dropdown | null;
    public constructor(props: ToolbarItemImageProps) {
        super(props);

        this.state = {
            selected: false,
            selectedIndex: this.getInitialSelectedIndex(this.props),
        };
    }


    public componentDidMount() {
        this.autorun = autorun(() => {
            const num = this.getMenuManager()?.hideAllMenuNum;
            const isOtherMenuShown = this.getMenuManager()?.isMenuShown || this.num !== num;
            this.num = Number(num);
            if (this.state.selected && isOtherMenuShown) {
                this.setState({ selected: false });
                this.hideDropDown();
            }
        });
    }

    public componentWillUnmount() {
        if (this.autorun) {
            this.autorun();
        }
    }
    // eslint-disable-next-line react/no-deprecated
    public componentWillReceiveProps(nextProps: ToolbarItemImageProps) {
        // if(nextProps.id === ActionType.SLIDE_SIZE) { //幻灯片设置在显示时更新
        //     return;
        // }
        let index = -1;
        if (this.hasDropdown(nextProps) && nextProps.dropdown.checkSelectedValue) {
            nextProps.dropdown.data.forEach((item, i) => {
                if (nextProps.value === item.id) {
                    index = i;
                }
            });
        }
        if (nextProps.disabled) { // 按钮灰置后，重置下拉按钮的选中状态
            this.setState({
                selected: false,
            });
        }
        this.setState({ selectedIndex: index });
    }
    // eslint-disable-next-line complexity
    public render() {
        let iconSelected = false;

        if (this.props.id === ActionType.ITEMNUMBER || this.props.id === ActionType.DIGITNUMBER) {
            if (this.props.value !== ItemSymbolType.ITEMSYMBOL_NONE) {
                iconSelected = true;
            }
        }
        const isQuickModel = this.props.model === StyleMode.QUICK_SETTING;
        const idPreFix = isQuickModel ? (`${StyleMode.QUICK_SETTING + (this.props.keyIndex || 0)}-`) : '';
        const isDropDownHover = this.isDropDownHover();

        if (this.hasDropdown(this.props)) {
            const belongID = idPreFix + (isDropDownHover ? `toolbar-dropdown-${this.props.id}` : `toolbar-${this.props.id}`);
            return (
                <React.Fragment>
                    <ItemComponent
                        {...this.props}
                        idPreFix={idPreFix}
                        iconSelected={iconSelected}
                        icon={this.getDisplayContent()}
                        dropdownHover={isDropDownHover}
                        onContentClick={this.handleContentClick}
                        handleClick={this.handleClick}
                    />
                    <Dropdown belongID={belongID}
                        autoClose={this.props.autoClosDropDown ?? true}
                        shadowType={'menu'}
                        offsetX={isDropDownHover ? -28 : 0}
                        ref={(ref) => {
                            this.dropDom = ref;
                        }}
                        autoAlign={true}
                        hasShadow = {!this.props.noShadow && this.props.dropdown.type !== DropdownType.INNER_TOOLBAR }
                        onVisibleChange={this.handleMenuVisibleChange}
                        style={this.props.isChart ? { padding: 0 } : undefined}>
                        {this.getDropContent()}
                    </Dropdown>
                </React.Fragment>
            );
        }
        return (
            <ItemComponent {...this.props}  idPreFix={idPreFix}/>
        );
    }


    private getInitialSelectedIndex(props: ToolbarItemImageProps) {
        let index = -1;
        if (this.hasDropdown(props) && props.dropdown.checkSelectedValue) {
            props.dropdown.data.forEach((item, i) => {
                if (props.value === item.id) {
                    index = i;
                }
            });
        }
        return index;
    }
    private hasDropdown(props: ToolbarItemImageProps) {
        if (props.dropdown?.data && props.dropdown.data.length > 0 && !props.disabled) {
            return true;
        }
        return false;
    }

    private handleMenuClick = (index: number) => {
        if (this.props.disabled) {
            return;
        }

        if (this.props.id === ActionType.BORDERSTYLE) {
            this.props.handleClick(this.props.id, index);
        } else if (this.props.id === ActionType.AI_PICTURE) {
            const itemData = this.props.dropdown.data[index];
            const idPreFix = `${StyleMode.QUICK_SETTING + (this.props.keyIndex || 0)}-`;
            const belongID = `${idPreFix}toolbar-${this.props.id}`;
            this.props.handleClick(this.props.id, itemData.id, { domId: belongID });
        } else {
            const itemData = this.props.dropdown.data[index]
            || this.props.dropdown.data.find(item => item.id === index);
            this.props.handleClick(this.props.id, itemData.id);
            // this.setState({ selectedIndex: index });
        }

        // if(this.props.id !== ActionType.BORDERSTYLE) {
        this.hideDropDown();
        // }
    };

    private handleContentClick = (e) => {
        if (this.props.disabled) {
            return;
        }
        if (this.props.id === ActionType.ITEMNUMBER) {
            e.stopPropagation();
            if (this.props.value === ItemSymbolType.ITEMSYMBOL_NONE) {
                this.props.handleClick(this.props.id, ItemSymbolType.ITEMSYMBOL_CIRCLE);
            } else {
                this.props.handleClick(this.props.id, ItemSymbolType.ITEMSYMBOL_NONE);
            }
        } else if (this.props.id === ActionType.DIGITNUMBER) {
            e.stopPropagation();
            if (this.props.value === ItemSymbolType.ITEMSYMBOL_NONE) {
                this.props.handleClick(this.props.id, OfficeNumberType.arabicPeriod);
            } else {
                this.props.handleClick(this.props.id, ItemSymbolType.ITEMSYMBOL_NONE);
            }
        } else if (this.props.id === ActionType.INDENT) {
            e.stopPropagation();
            this.props.handleClick(this.props.id, IndentType.INDENT_INCREASE);
        } else if (this.props.id === ActionType.TAILOR_PIC) {
            e.stopPropagation();
            this.handleTailorClick();
        } else if (this.props.id === ActionType.RESET_PICTURE) {
            e.stopPropagation();
            this.props.handleClick(this.props.id);
        }
    };

    private handleInserTableMenuClick = () => {
        // this.props.handleClick(this.props.id, data);
        this.hideDropDown();
    };

    private handleMenuVisibleChange = (visible) => {
        if (this.props.id === ActionType.ADDON) {
            const addonHandler = this.getAddonManager().addonHandler as IAddonHandler;
            const type = addonHandler.getSceneType();
            const aid = (this.getAppSerive().viewableServiceLayer
                .selectionService.getSelectedModel()?.props as IElementModelProps).addon?.docElement.addonId;
            addonHandler.updateQuickMenu(type, aid);
        }
        if (this.hasDropdown(this.props)) {
            this.setState({ selected: visible });
        }
        if (visible) {
            setTimeout(() => { // 延迟一下，确保左右切换菜单时状态正确
                this.getToolbarStateManager().isToolbarMenuShown = true;
            }, 50);
        } else {
            this.getToolbarStateManager().isToolbarMenuShown = false;
        }
    };

    private getDisplayContent() {
        let displayContent = this.props.icon;
        if (this.hasDropdown(this.props) && this.state.selectedIndex >= 0 && this.props.showSelectedValue === true) {
            const itemData = this.props.dropdown.data[this.state.selectedIndex];
            if (itemData.icon !== undefined && itemData.icon !== null) {
                displayContent = itemData.icon;
            }
        }
        return displayContent;
    }

    private getDropContent() {
        const dropdown = { ...this.props.dropdown };
        if (this.props.id === ActionType.ITEMNUMBER) {
            dropdown.itemWidth = 32;
            dropdown.itemHeight = 32;
            dropdown.itemPadding = 0;
            dropdown.showBorder = true;
        } else if (this.props.id === ActionType.DIGITNUMBER) {
            dropdown.itemWidth = 60;
            dropdown.itemHeight = 80;
            dropdown.itemPadding = 0;
            dropdown.showBorder = true;
        } else if (this.props.id === ActionType.INSERT_FORM) {
            dropdown.itemWidth = 12;
            dropdown.itemHeight = 12;
            dropdown.itemPadding = 0;
            dropdown.showBorder = true;
        } else if (this.props.id === ActionType.HORIZONTAL_ALIGN || this.props.id === ActionType.VERTICAL_ALIGN) {
            dropdown.itemWidth = 32;
            dropdown.itemWidth = 70;
            dropdown.itemHeight = 32;
            dropdown.itemPadding = '4px 23px';
            dropdown.showBorder = false;
        } else if (this.props.id === ActionType.INDENT) {
            dropdown.itemWidth = 70;
            dropdown.itemHeight = 32;
            dropdown.itemPadding = 4;
            dropdown.showBorder = false;
        } else {
            dropdown.itemWidth = 32;
            dropdown.itemHeight = 32;
            dropdown.itemPadding = 4;
            dropdown.showBorder = false;
        }
        return (
            <DropContent
                {...dropdown}
                id={this.props.id}
                selectedIndex={this.state.selectedIndex}
                menuValue={this.props.value}
                hideMenu={this.hideDropDown}
                onMenuClick={this.props.id === ActionType.INSERT_FORM
                    ? this.handleInserTableMenuClick
                    : this.handleMenuClick
                }
                handleClick={this.props.handleClick}
                rightSideBarManager={this.props.rightSideBarManager}
                selectionService={this.getSelectionService()}
                menuManager={this.getMenuManager()}
                chartTrendlineManager={this.getChartTrendlineManager()}
            />
        );
    }

    private hideDropDown = () => {
        if (this.dropDom) {
            this.dropDom.hide();
        }
    };

    private isDropDownHover = () => this.props.id === ActionType.ITEMNUMBER
        || this.props.id === ActionType.DIGITNUMBER
        || this.props.id === ActionType.TAILOR_PIC
        || this.props.id === ActionType.RESET_PICTURE
        || this.props.id === ActionType.INDENT;


    private handleQuickSettingClick = (model) => {
        // 点击上报
        let action;
        if (model.type === UIModelType.SHAPE) {
            if (model.isTextOrPlaceholder) {
                action = TDWActionType.TEXT_LEVEL_ADJUST;
            } else {
                action = TDWActionType.SHAPE_LEVEL;
            }
        } else if (model.type === UIModelType.IMAGE) {
            action = TDWActionType.PIC_LEVEL_ADJUST;
        } else if (model.type === UIModelType.TABLE) {
            action = TDWActionType.EXL_LEVEL_ADJUST;
        }
        if (action) {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_EDIT_FORMAT,
                action,
            });
        }
    };

    private handleClick = () => {
        const isQuickModel = this.props.model === StyleMode.QUICK_SETTING;
        const isUnshowDropdown = this.dropDom && !this.dropDom.isShown();
        if (isQuickModel && this.props.id === ActionType.MOVE_ITEM && isUnshowDropdown) {
            const model = this.getSelectionService().getSelectedModel();
            this.handleQuickSettingClick(model);
        }

        if (this.props.id === ActionType.EFFECT && isUnshowDropdown) {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_EDIT_PROFORMAT_PA,
                action: TDWActionType.OPEN_TOOLBAR_EFFECT,
            });
        }
    };

    private handleTailorClick() {
        const type = this.getSelectionService().getSelectedModel()?.type;
        if (type && [UIModelType.IMAGE, UIModelType.SHAPE].includes(type)) {
            this.props.handleClick(ActionType.TAILOR_PIC_NORMAL);
        }
    }

    private getAddonManager() {
        return this.getAppSerive().viewableServiceLayer.addonManager;
    }

    private getMenuManager() {
        return this.getAppSerive().editableServiceLayer?.menuManager;
    }

    private getSelectionService() {
        return this.getAppSerive().viewableServiceLayer.selectionService;
    }

    private getChartTrendlineManager() {
        return this.getAppSerive()?.editableServiceLayer?.chartTrendlineManager;
    }

    private getToolbarStateManager = () => this.getAppSerive().viewableServiceLayer
        .toolbarStateManager;

    private getAppSerive() {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }
}
